<template>
  <div id="galleryModal" class="row">
    <div class="photos-gallery">
      <div class="big-photo col-12 col-lg-9" v-on:click.stop="openGalleryModal()">
        <div v-on:click.stop="decrementIndex()" class="icon icon-left">
          <span class="">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" class="bi bi-arrow-bar-left"
              viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5zM10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5z" />
            </svg>
          </span>
        </div>
        <img :src="photos[currentIndex] ? photos[currentIndex].d_image : 'no photo found'" class="cover">

        <div v-on:click.stop="incrementIndex()" class="icon icon-right">
          <span class="">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8zm-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5z" />
            </svg>
          </span>
        </div>
      </div>
      <div class="small-photo-list d-none d-lg-block">
        <div v-for="(photo, index) in photos" :key="index" v-on:click="setIndex(index)">
          <img :src="photo.d_image" :alt="photo.d_imageAlt" class="w-100 cover mb-1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BienPhotosGallery',
  props: {
    photos: Array
  },
  data: function () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    incrementIndex() {
      this.currentIndex += 1
      if (this.currentIndex >= this.photos.length) this.currentIndex = 0
    },
    decrementIndex() {
      this.currentIndex -= 1
      if (this.currentIndex < 0) this.currentIndex = this.photos.length - 1
    },
    setIndex(index) {
      this.currentIndex = index
    },
    openGalleryModal() {
      document.getElementById("galleryModal").classList.toggle("gallery-background")
    }
  }
}
</script>

<style lang="scss">
.gallery-background {
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.8);
  /* Black w/ opacity */
  padding: 50px;

  .photos-gallery {
    max-height: 100%;
    width: 100%;
    justify-content: center;

    .big-photo {
      width: auto;
      max-width: max-content;
      cursor: zoom-out;

      img {
        width: auto;
        height: auto;
      }
    }
  }
}

.photos-gallery {
  max-height: 500px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .big-photo {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
    max-width: 564px;
    cursor: zoom-in;

    img {
      width: auto;
      height: auto;
      max-height: 100%;
      max-width: 100%;
    }

    .icon {
      font-size: 3rem;
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      height: 100%;
      cursor: pointer;
    }

    .icon-left {
      left: 0px;
      top: 0px;
    }

    .icon-right {
      right: 0px;
      top: 0px;
    }

    .icon:hover {
      background-color: rgba(128, 128, 128, 0.253);
    }
    
  }

  .small-photo-list {
    overflow-y: auto;
    height: 100%;
    width: 216px;
    margin-left: 16px;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

  }

  .small-photo-list img {
    cursor: pointer;
  }
}

</style>
